export default __webpack_public_path__ + "static/media/release-notes.51da87d8.svg";